import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../common/constants';
import { inviteUserUrl } from '../../config';
import { RootState } from '../../store';
import { ICreateUser, ICreateUserResponse } from "../../common/types/userTypes";
import axios from 'axios';
import api from '../../api';

const INVITE_USER: string = "inviteUser";

export interface IinviteUserData {
  isPasswordEnable?: boolean;
  password?: string;
}

interface IInitialState {
  status: string;
  data: IInviteUserResponse | null;
  error: string | null;
}

const initialState: IInitialState = {
  status: Status.IDLE,
  data: null,
  error: null,
};

export interface IInviteUserResponse {
  status: number;
  message: string;
}

export const inviteUser = createAsyncThunk(INVITE_USER, async (payload: ICreateUser, { rejectWithValue }) => {
  try {
    const response = await api.post<IInviteUserResponse>(inviteUserUrl, payload);
    const createUserResponse: IInviteUserResponse = response.data;
    return createUserResponse;
  } catch (error) {
    throw rejectWithValue(error);
  }
}
);

const inviteUserSlice = createSlice({
  name: "inviteUser",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inviteUser.pending, (state) => {
        state.status = Status.PENDING;
        state.data = null;
      })
      .addCase(inviteUser.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = Status.SUCCESS;
      })
      .addCase(inviteUser.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
        // state.data = action.payload || 'Something went wrong!' ;
      });
  },
});

type Selector = {
  inviteUserApi: ReturnType<
    typeof inviteUserSlice.reducer
  >;
};

export const selector = (store: Selector) => store['inviteUserApi'];

export default inviteUserSlice.reducer;